// Formularios que NO tienen página en el PDF oficial del Anexo 1 del MSP
// (AM 00115-2021 + Fe de errata). En pantalla llevan una insignia que dice de
// dónde vienen realmente, para no presentarlos como formularios de la HCU 2021.
// El CÓDIGO interno no cambia (rutas, datos guardados y catálogo dependen de
// él): esto solo gobierna el rótulo visible.
//
// - 'propio': diseño de LogiaCare, sin fuente oficial.
// - 'propio-norma': diseño propio con otra norma como base (FEMO, AM 00025-2025).
// - 'msp-seguridad-2016': formulario oficial del MSP del Manual de Seguridad del Paciente (2016), no de la HCU 2021.
// - 'msp-hcu-2008': figuraba en la HCU 2008 (AM 000138); fuente solo secundaria, sin afirmar vigencia.
export type TipoFormularioPropio = 'propio' | 'propio-norma' | 'msp-seguridad-2016' | 'msp-hcu-2008';

export interface FormularioPropio {
  readonly tipo: TipoFormularioPropio;
  /** Solo 'propio-norma': la norma que lo respalda, tal como se rotula. */
  readonly norma?: string;
}

export const FORMULARIOS_PROPIOS: Readonly<Record<string, FormularioPropio>> = {
  '034': { tipo: 'propio' },
  '054': { tipo: 'msp-hcu-2008' },
  '055': { tipo: 'msp-hcu-2008' },
  '059': { tipo: 'msp-seguridad-2016' },
  'enf-soapie': { tipo: 'propio' },
  'esc-phq9': { tipo: 'propio' },
  'esc-nyha': { tipo: 'propio' },
  'esc-glasgow': { tipo: 'propio' },
  FEMO: { tipo: 'propio-norma', norma: 'AM 00025-2025' },
};

/** Clave i18n (bajo `formulario.`) de la insignia de cada categoría. */
export const CLAVE_INSIGNIA: Readonly<Record<TipoFormularioPropio, string>> = {
  propio: 'insigniaPropio',
  'propio-norma': 'insigniaPropioNorma',
  'msp-seguridad-2016': 'insigniaMspSeguridad2016',
  'msp-hcu-2008': 'insigniaMspHcu2008',
};

export function formularioPropio(codigo: string): FormularioPropio | undefined {
  return Object.hasOwn(FORMULARIOS_PROPIOS, codigo) ? FORMULARIOS_PROPIOS[codigo] : undefined;
}
